import React from 'react';
import loadable from '@loadable/component';
import type { Props } from './mega-menu';

const MegaMenuLoadable = loadable(
  () => import(/* webpackChunkName: "mega-menu" */ './mega-menu')
);

const MegaMenu = (props: Props) => <MegaMenuLoadable {...props} />;

export default MegaMenu;
